import axios from "axios"

const fetchData = async (searchURL, then, onError, after) => {
    await axios.get( searchURL)
        .then( res => {
            const data = res
            then(data) 
        })
        .catch ( error => {
            if( axios.isCancel(error) || error ){
                onError(error)
            }
        })
        .finally(() => {
            return after ? after() : null
        })
}

export {fetchData}